export function getColoresFecha(tipo) {
  let colores = {};

  switch (tipo) {
    case "completado":
      colores = { color: '#388E3C', background: '#81c784' };
      break;
    case "pronto":
      colores = { color: '#000000', background: '#FFF9C4' };
      break;
    case "vencido":
      colores = { color: '#D32F2F', background: '#FFCDD2' };
      break;
    default:
      colores = { color: '#000000', background: '#AAD6F3' };
      break;
  }

  return colores;
}
